var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "loading-screen" }, [
    _c("div", { staticClass: "loading-screen__content" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "loading-screen__title" }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "loading-screen__details" },
        [
          _vm._v("\n      " + _vm._s(_vm.details) + "\n      "),
          _vm._t("default"),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loading-screen__logo" }, [
      _c("img", { attrs: { alt: "Loading", src: "/images/logo-icon.png" } }),
      _vm._v(" "),
      _c("div", { staticClass: "loading-screen__logo__overlay" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }